export const DEFAULT_MILESTONE_COLOR_NAME = 'Azure';

export const DEFAULT_PROGRESS_PERCENTAGE = 1;

export const DEFAULT_MILESTONE_PROGRESS = {
  name: 'Undefined',
  progress: DEFAULT_PROGRESS_PERCENTAGE,
};
